import { create } from 'zustand';

const useAssetsStore = create((set) => ({
    assets: null,
    storeAssets: (assets) => set(() => ({ assets: assets }))
}));

export default useAssetsStore;